import { ApplePayConstants } from 'constants/applePay';
import { createAction } from 'redux-actions';

export const validateMerchant = createAction(ApplePayConstants.VALIDATE_MERCHANT);
export const sendQuickpayText = createAction(ApplePayConstants.SEND_QUICKPAY_TEXT);
